module.exports = __webpack_public_path__ + "media/social/link-fb@2x-c42d729a.png";